import { render, staticRenderFns } from "./AdminApp.vue?vue&type=template&id=db432976&"
import script from "./AdminApp.vue?vue&type=script&lang=js&"
export * from "./AdminApp.vue?vue&type=script&lang=js&"
import style0 from "./AdminApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports